// extracted by mini-css-extract-plugin
module.exports = {"base":"AsSeenIn_base__Ulekp","title":"AsSeenIn_title__lQoOh","logoContainer":"AsSeenIn_logoContainer__Zc0CJ"};